<script>
  import ProfileImg from './ProfileImage.svelte';
  import { client } from 'root/api/index.js';
  import { Modal } from 'bootstrap';
  import { getContext, onDestroy } from 'svelte';
  import Loader from './Loader.svelte';
  import { navigate } from 'svelte-routing';
  import { getUserInfo } from '../stores/auth';

  import {
    itemIndexOf,
    searchKeyByValue,
    customInputEvent,
    setYupMessage,
  } from 'components/Helper.js';
  const showDialog = getContext('showDialog');
  let userProfileModal;
  let id = 0;
  export const show = (userId) => {
    userProfileModal = new Modal(document.getElementById('userProfileModal'), {
      keyboard: false,
    });
    userProfileModal.show();
    id = userId;
    getUserDetail();
  };
  export const hide = () => {
    if (userProfileModal != undefined) {
      userProfileModal.hide();
    }
  };

  let ajaxLoading = true;
  let defaultValue = {};
  let form = {};

  let selectedRoleId = null;
  let selectedDateFormatId = null;
  let selectedTimeZoneId = null;
  let selectedUnitId = null;
  let selectedUsers = null;
  let selectedUnitClient = {};
  let selectedUnitUser = {};
  let serverErrors = [];
  let oldPhotoUrl = null;
  let fileObj;
  let mobileObj = { mobile: '' };
  let selectedUnits = [];
  let userRoles = {};
  let role = [];
  let timeZones = [];
  let dateFormates = [];
  let isManager = false;
  const getUserDetail = () => {
    ajaxLoading = true;
    form = { ...defaultValue };
    selectedRoleId = null;
    selectedDateFormatId = null;
    selectedTimeZoneId = null;
    selectedUnitClient = {};
    selectedUnitUser = {};
    serverErrors = [];
    client
      .userDetail({ id: id })
      .then((response) => {
        response.data.units.map((item) => {
          selectedUnitClient[item.id] = item.clients;
        });
        response.data.users.map((item) => {
          if (selectedUnitUser[item.unitId] == undefined) {
            selectedUnitUser[item.unitId] = [];
          }
          selectedUnitUser[item.unitId].push(item);
        });

        oldPhotoUrl = response.data.photoUrlPath;

        form = response.data;
        form.file = fileObj;
        form.password = '';
        form.confirmPassword = '';
        selectedUsers = response.data.users;
        selectedUnitId = response.data.units;
        selectedUnits = [];
        selectedUnitId.forEach((element) => {
          if (id == 0 || element.accessStatus) {
            selectedUnits.push({ unitId: element.id });
          }
        });
        setDropDown();
        isManager = userRoles.manager == form.roleId;
        // isManagerSelect();
        // getUnitUsers()
        ajaxLoading = false;
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };

  import { masterData, getMasterData } from '../stores/masterData.js';
  import TaskGroup from './TaskDashboard/TaskGroup.svelte';
  import CreateGroup from './TaskDashboard/CreateGroup.svelte';
  let units = [];
  let userRolesIndex = null;
  let userRoleId = null;
  const unsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        role = getMasterData().roles;
        timeZones = getMasterData().timeZones;
        dateFormates = getMasterData().dateFormates;
        userRolesIndex = getMasterData().userRoleId;
        userRoleId = getUserInfo().roleId;
        units = getMasterData().units.map((item) => {
          item.accessStatus = true;
          return item;
        });
        userRoles = getMasterData().userRoleId;
      }
    });
  });

  onDestroy(() => {
    unsubscribe();
  });

  const setDropDown = () => {
    if (form.roleId > 0 && role.length > 0) {
      selectedRoleId = {
        id: form.roleId,
        name: role[searchKeyByValue(role, 'id', form.roleId)].name,
      };
    }
    if (form.timeZoneId > 0 && timeZones.length > 0) {
      selectedTimeZoneId = {
        id: form.timeZoneId,
        name: timeZones[searchKeyByValue(timeZones, 'id', form.timeZoneId)].name,
      };
    }
    if (form.dateFormatId > 0 && dateFormates.length > 0) {
      selectedDateFormatId = {
        id: form.dateFormatId,
        name: dateFormates[searchKeyByValue(dateFormates, 'id', form.dateFormatId)].name,
      };
    }
  };

  let createGroupModal;
  let createFilterGroupModal;
  let groupUsers = [];
  const saveGroup = (data) => {
    createGroupModal = new Modal(document.getElementById('creatGroupModal'), {
      keyboard: false,
    });
    createGroupModal.show();
    createFilterGroupModal.show(
      form.users.map((item) => {
        item.id = item.userId;
        return item;
      }),
      data,
    );
    createGroupModal.show();
  };
  let taskGroupModal;
  const showGroup = () => {
    taskGroupModal.show(form.id, 'user');
  };
</script>

<div
  class="modal fade slide-modal show"
  id="userProfileModal"
  tabindex="-1"
  aria-labelledby="userProfileModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog w-100 add-task-modal h-100 m-0 float-end">
    <div class="modal-content">
      {#if ajaxLoading}
        <Loader type="overlay" />
      {:else}
        <div class="d-flex flex-column h-100">
          <div class="modal-header rounded-0 d-flex flex-column">
            <div class="d-flex flex-row justify-content-between w-100">
              <h5 class="mb-0 font-size-13 color-black">
                {form.firstName + ' ' + form.lastName}
              </h5>
              <span class="d-inline-block position-relative">
                {#if userRoleId != null && userRolesIndex.manager != userRoleId && form.isEdit}
                  <button
                    class="btn bg-transparent"
                    style="padding: 0; position: absolute; top: -7px; left: 10px;"
                    on:click={() => {
                      (hide(), navigate(`/user/edit/${form.id}`));
                    }}
                  >
                    <img
                      class="icon-17"
                      alt=""
                      src="/images/pencil-gray.svg"
                    />
                  </button>
                {/if}
              </span>
              <button
                type="button"
                class="close btn-close"
                on:click={() => hide()}
              ></button>
            </div>
          </div>

          <div class="page-content">
            <div class="p-3 content-section pb-0">
              <span class="font-size-14 mb-2 font-weight-500 d-block">User Profile</span>
              <div class="row mb-1">
                <div class="col-md-12">
                  <div class="box-block rounded p-2 client-type-main">
                    <div class="row mt-0">
                      <div class="col-md-10">
                        <div class="row mt-0">
                          <div class="col-md-4">
                            <span class="title color-blue d-block mb-1 font-weight-500"
                              >First Name</span
                            >
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.firstName}</span
                            >
                          </div>
                          <div class="col-md-4">
                            <span class="title color-blue d-block mb-1 font-weight-500"
                              >Last Name</span
                            >
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.lastName}</span
                            >
                          </div>
                          <div class="col-md-4">
                            <span class="title color-blue d-block mb-1 font-weight-500">Title</span>
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.title}</span
                            >
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-4">
                            <span class="title color-blue d-block mb-1 font-weight-500">Email</span>
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.email}</span
                            >
                          </div>
                          <div class="col-md-4">
                            <span class="title color-blue d-block mb-1 font-weight-500">Role</span>
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.roleName}</span
                            >
                          </div>
                          <div class="col-md-4">
                            <span class="title color-blue d-block mb-1 font-weight-500"
                              >Legacy Company</span
                            >
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.legacyCompanyName}</span
                            >
                          </div>
                        </div>
                        <div class="row mt-3">
                          <div class="col-md-12">
                            <span class="title color-blue d-block mb-1 font-weight-500"
                              >Associated Region</span
                            >
                            <span class="font-size-12 font-weight-400 d-block text-break"
                              >{form.associatedRegionName}</span
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-md-2 text-center">
                        <ProfileImg
                          size={90}
                          photoUrl={form.photoUrlPath}
                          firstName={form.firstName}
                          lastName={form.lastName}
                          className="d-inline-block align-middle user-prfoile-img"
                        />
                      </div>
                    </div>

                    <div class="row mt-3">
                      <div class="col-md-12">
                        <label
                          for=""
                          class="mb-1 font-weight-500">Business Unit</label
                        >
                        <div class="d-flex flex-row flex-wrap">
                          {#each form.units as item}
                            <div
                              class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                            >
                              <div
                                class="  d-flex flex-row justify-content-between align-items-center"
                              >
                                <span class="text-break">{item.name}</span>
                              </div>
                            </div>
                          {/each}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {#if isManager}
              <div class="p-3 content-section pb-0">
                <div class="d-flex mb-2 justify-content-between align-items-center">
                  <span class="font-size-14 font-weight-500 d-block">Subordinate Users</span>
                  {#if form.canViewGroup && form.canViewGroup == 1}
                    <button
                      type="button"
                      class="task-filter-icon btn btn-primary border-0 px-2 rounded ms-2 text-nowrap font-size-13"
                      on:click={showGroup}
                    >
                      User Groups
                    </button>
                  {/if}
                </div>
                <div class="row mb-1">
                  <div class="col-md-12">
                    <div class="box-block rounded p-2 client-type-main">
                      {#each form.units as unit, i}
                        <div class="row mt-0 {i > 0 ? 'mt-3' : ''}">
                          <div class="col-md-12">
                            <label
                              for=""
                              class="mb-1 font-weight-500">{unit.name} User</label
                            >
                            <div class="d-flex flex-row flex-wrap">
                              {#if selectedUnitUser[unit.id]}
                                {#each selectedUnitUser[unit.id] as user}
                                  <div
                                    class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                                  >
                                    <div
                                      class="  d-flex flex-row justify-content-between align-items-center"
                                    >
                                      <span class="text-break"
                                        >{user.firstName + ' ' + user.lastName}</span
                                      >
                                    </div>
                                  </div>
                                {/each}
                              {:else}
                                <div
                                  class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                                >
                                  <div
                                    class="  d-flex flex-row justify-content-between align-items-center"
                                  >
                                    <span class="text-break"> No subordinate users assigned</span>
                                  </div>
                                </div>
                              {/if}
                            </div>
                          </div>
                        </div>
                      {/each}
                    </div>
                  </div>
                </div>
              </div>
            {/if}

            <div class="p-3 content-section pb-0">
              <span class="font-size-14 mb-2 font-weight-500 d-block">Delivery Verticals</span>
              <div class="row mb-1">
                <div class="col-md-12">
                  <div class="box-block rounded p-2 client-type-main">
                    <div class="row mt-0">
                      <div class="col-md-12">
                        <label
                          for=""
                          class="mb-1 font-weight-500">Regulatory Services Verticals</label
                        >
                        <div class="d-flex flex-row flex-wrap">
                          {#if form.deliveryVerticals.length > 0}
                            {#each form.deliveryVerticals as deliveryVertical, i}
                              <div
                                class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                              >
                                <div
                                  class="  d-flex flex-row justify-content-between align-items-center"
                                >
                                  <span class="text-break">{deliveryVertical.name}</span>
                                </div>
                              </div>
                            {/each}
                          {:else}
                            <div
                              class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                            >
                              <div
                                class="  d-flex flex-row justify-content-between align-items-center"
                              >
                                <span class="text-break">No delivery vertical assigned</span>
                              </div>
                            </div>
                          {/if}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-3 content-section pb-0">
              <span class="font-size-14 mb-2 font-weight-500 d-block">Associated Clients</span>
              <div class="row mb-1">
                <div class="col-md-12">
                  <div class="box-block rounded p-2 client-type-main">
                    {#each form.units as unit, i}
                      <div class="row mt-0 {i > 0 ? 'mt-3' : ''}">
                        <div class="col-md-12">
                          <label
                            for=""
                            class="mb-1 font-weight-500">{unit.name} Client</label
                          >
                          <div class="d-flex flex-row flex-wrap">
                            {#if selectedUnitClient[unit.id]}
                              {#each selectedUnitClient[unit.id] as client}
                                <div
                                  class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                                >
                                  <div
                                    class="  d-flex flex-row justify-content-between align-items-center"
                                  >
                                    <span class="text-break">{client.name}</span>
                                  </div>
                                </div>
                              {/each}
                            {:else}
                              <div
                                class="mb-1 me-1 rounded subcateogry-name d-inline-block px-2 py-1 mb-1"
                              >
                                <div
                                  class="  d-flex flex-row justify-content-between align-items-center"
                                >
                                  <span class="text-break">No clients assigned</span>
                                </div>
                              </div>
                            {/if}
                          </div>
                        </div>
                      </div>
                    {/each}
                  </div>
                </div>
              </div>
            </div>

            <div class="p-3 content-section pb-0">
              <span class="font-size-14 mb-2 font-weight-500 d-block">Contact Detail</span>
              <div class="row mb-1">
                <div class="col-md-12">
                  <div class="box-block rounded p-2 client-type-main">
                    <div class="row mt-0">
                      <div class="col-md-4">
                        <span class="title color-blue d-block mb-1 font-weight-500"
                          >Mobile Number</span
                        >
                        {#each form.mobileNos as mobileNo, key}
                          <span class="font-size-12 font-weight-400 text-break"
                            >{key > 0 ? ', ' : ''}{mobileNo.mobile}</span
                          >
                        {/each}
                      </div>
                      <div class="col-md-4">
                        <span class="title color-blue d-block mb-1 font-weight-500">Country</span>
                        <span class="font-size-12 font-weight-400 d-block text-break"
                          >{form.countryName}</span
                        >
                      </div>
                      <div class="col-md-4">
                        <span class="title color-blue d-block mb-1 font-weight-500">State</span>
                        <span class="font-size-12 font-weight-400 d-block text-break"
                          >{form.stateName}</span
                        >
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-md-4">
                        <span class="title color-blue d-block mb-1 font-weight-500"
                          >Date Format</span
                        >
                        <span class="font-size-12 font-weight-400 d-block text-break"
                          >{selectedDateFormatId ? selectedDateFormatId.name : ''}</span
                        >
                      </div>
                      <div class="col-md-8">
                        <span class="title color-blue d-block mb-1 font-weight-500">Time Zone</span>
                        <span class="font-size-12 font-weight-400 d-block"
                          >{selectedTimeZoneId ? selectedTimeZoneId.name : ''}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<TaskGroup
  bind:this={taskGroupModal}
  showGroup={(flag, data) => {
    if (flag == 'add') {
      saveGroup({
        userId: form.id,
        id: '',
        readonly: 1,
        name: '',
        users: [],
      });
    } else {
      saveGroup({
        userId: form.id,
        id: data.id,
        readonly: data.readonly,
        name: data.name,
        users: data.users,
      });
    }
  }}
/>
<CreateGroup
  bind:this={createFilterGroupModal}
  comeFrom="user"
  saveGroup={(event) => {
    client
      .taskFilterGroupSave({
        ...event,
        comeFrom: 'user',
      })
      .then(async (result) => {
        createGroupModal.hide();
      })
      .catch((err) => {
        showDialog({ message: [err.message] });
      });
  }}
/>
